import React from 'react'
import { TrashIcon } from '@heroicons/react/24/outline'
import ExpandyPanel from '~/lib/ui/ExpandyPanel'
import {
  EditorTextArea,
  useEditorItem,
  EditorYearMonthField,
} from './EditorItemProvider'
import { useTranslation } from '~/hooks/useTranslation'

const AwardItem = () => {
  const { t } = useTranslation('AwardsItem')
  const { index, activeIndex, setActiveIndex, item, deleteItem } =
    useEditorItem()

  const headingLabel = item.summary || t('new_achievement')

  const toggleExpanded = () => {
    if (activeIndex == index) {
      setActiveIndex(-1)
    } else {
      setActiveIndex(index)
    }
  }

  const expanded = activeIndex == index

  return (
    <div className="mb-4 flex flex-row items-center">
      <ExpandyPanel
        headingText={headingLabel}
        expanded={expanded}
        index={index}
        onClick={toggleExpanded}
        minHeight="min-h-auto"
        className="flex-grow"
      >
        <div
          id={`award-${index}`}
          className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2"
        >
          <EditorTextArea
            label={t('summary')}
            fieldName="summary"
            containerClassName="md:col-span-2"
          />
          <EditorYearMonthField label={t('date')} fieldName="date" />
        </div>
      </ExpandyPanel>
      {!expanded && (
        <button
          onClick={deleteItem}
          className="max-w-min text-[#b9b9b9]"
          aria-label={t('remove_achievement')}
        >
          <TrashIcon className="ml-2 w-8" />
        </button>
      )}
    </div>
  )
}
export default AwardItem
